import { render, staticRenderFns } from "./returned.vue?vue&type=template&id=04f94419&"
import script from "./returned.vue?vue&type=script&lang=js&"
export * from "./returned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports